// extracted by mini-css-extract-plugin
export default {"pane":"_ae966a07","content":"_da635134","trigger":"_21bc205","arrow":"_69f6b824","arrowDown":"_97af7ef6","negotiationDisclaimer":"_9189bc9d"};